import {NgModule, ModuleWithProviders,CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import {CommonModule, CurrencyPipe, DecimalPipe  } from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";

import {RxCoreModule, RegularExpression } from "../core";

import {RxPlaceholderDirective, RxTabindexDirective,
    RxCurrencyDirective, RxDecimalDirective ,
    RxFocusDirective, RxControlIndexDirective,
    RxMaskDirective,
    RxDateComponent,
    RxPickerComponent,
    RxDatePickerComponent,
    RxMonthPicker,
    RxTimeComponent, RxTagComponent, RxMessageComponent, RxMessageDirective
} from './forms'

@NgModule({
    declarations: [RxPlaceholderDirective, RxTabindexDirective,
        RxFocusDirective, RxControlIndexDirective, RxMaskDirective
        , RxCurrencyDirective, RxDecimalDirective, RxDateComponent,
        RxPickerComponent,
        RxDatePickerComponent,
        RxMonthPicker,
        RxTimeComponent, RxTagComponent, RxMessageComponent, RxMessageDirective
    ],
    exports: [RxPlaceholderDirective, RxTabindexDirective,
        RxCurrencyDirective, RxDecimalDirective, RxFocusDirective, RxControlIndexDirective,
        RxMaskDirective,
        RxDateComponent,
        RxPickerComponent,
        RxDatePickerComponent,
        RxMonthPicker,
        RxTimeComponent, RxTagComponent, RxMessageDirective],
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    providers: [CurrencyPipe, DecimalPipe, RegularExpression],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RxFormsModule {
    static forRoot(): ModuleWithProviders { return { ngModule: RxFormsModule, providers: [] }; }
}


// WEBPACK FOOTER //
// ./node_modules/@rx/forms/forms.module.ts